// Internal traffic marker (BUG-527, plan G5).
//
// The owner and staff browse the site from many networks (salons, phones), so
// an IP filter alone cannot keep them out of the reports. Opening any page with
// `?internal=1` marks this browser as internal until `?internal=0`:
//   - GA4 gets `traffic_type: 'internal'` (its Internal Traffic data filter);
//   - Clarity gets the session tag `internal = 1`;
//   - Umami's own opt-out key `umami.disabled` is set, so Umami sends nothing.
// `?internal=0` clears both keys (also an `umami.disabled` set by hand).

export const INTERNAL_STORAGE_KEY = 'helin-internal-traffic'
/** Umami's built-in opt-out: its tracker sends nothing while this key is set. */
export const UMAMI_OPT_OUT_KEY = 'umami.disabled'

/** Reads `?internal=1` / `?internal=0` from the page's query string and stores the choice. */
export function syncInternalMarker(search: string): void {
  const value = new URLSearchParams(search).get('internal')
  try {
    if (value === '1') {
      window.localStorage.setItem(INTERNAL_STORAGE_KEY, '1')
      window.localStorage.setItem(UMAMI_OPT_OUT_KEY, '1')
    } else if (value === '0') {
      window.localStorage.removeItem(INTERNAL_STORAGE_KEY)
      window.localStorage.removeItem(UMAMI_OPT_OUT_KEY)
    }
  } catch {
    // Storage blocked: the marker simply does not stick.
  }
}

/** True while this browser is marked as internal traffic. */
export function isInternalTraffic(): boolean {
  try {
    return window.localStorage.getItem(INTERNAL_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}
